<form [formGroup]="fcMergeItemModalFormGroup" id="{{baseId}}-modal-form" #form="ngForm" (ngSubmit)="onSave()">
  <div class="emds">
    <div class="modal-default modal-flex">
      <div class="modal-header">
        <span id="{{baseId}}-header-title" translate>Replace</span>
      </div>

      <div class="modal-body">
        <span id="{{baseId}}-replace-instructions" translate>
          You have selected to replace the {{fcName}} item of {{fcItemName}}.  Everywhere this item is used in the system, will
          now be replaced with the item you selected below.  This operation will save any changes already made and cannot be undone.
        </span>

        <div class="form-group">
          <label translate>New Item</label>
          <ap-findcontrol [baseId]="baseId + '-new-item-find-control'"
                          [(selectedPk)]="newUid"
                          [findControlId]="findControlBehaviorId"
                          [additionalSearchParameters]="itemToExcludeAdditionalSearchParams"
                          [apFormGroup]="fcMergeItemModalFormGroup"
                          [form]="form"
                          [controlName]="'newItemFindControl'"
                          [singleSelect]="true"
                          [required]="true"
                          [findControlDisplayName]="findControlDisplayName"
                          [hiddenActionItems]="hiddenActionItems">
          </ap-findcontrol>
          <ng-container *ngIf="form.submitted && newUid === dataItem.Pk">
            <div id="{{baseId}}-warning-selected-id-equals-replace-id" class="incorrect-input" translate>
              New Item cannot be the same as the item being replaced
            </div>
          </ng-container>
        </div>
      </div>

      <div class="modal-footer">
        <button type="submit"
                id="{{baseId}}-save-btn"
                class="btn btn-primary"
                [disabled]="!fcMergeItemModalFormGroup?.dirty || isSaving">
          <ap-spinner *ngIf="isSaving; else notSaving" size="1"></ap-spinner>
          <ng-template #notSaving>
            Save
          </ng-template>
        </button>

        <button type="button"
                id="{{baseId}}-cancel-btn"
                class="btn btn-secondary btn-flush-right"
                (click)="onCancel()" translate>
          Cancel
        </button>
      </div>
    </div>
  </div>
</form>
